var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { NodeRegistryABI } from '@streamr/network-contracts';
import { toEthereumAddress } from '@streamr/utils';
import { Lifecycle, inject, scoped } from 'tsyringe';
import { Identity, IdentityInjectionToken } from '../identity/Identity';
import { ConfigInjectionToken } from '../ConfigTypes';
import { RpcProviderSource } from '../RpcProviderSource';
import { StreamrClientError } from '../StreamrClientError';
import { getEthersOverrides } from '../ethereumUtils';
import { ContractFactory } from './ContractFactory';
import { waitForTx } from './contract';
/**
 * Store a mapping of storage node addresses <-> storage node URLs
 */
let StorageNodeRegistry = class StorageNodeRegistry {
    nodeRegistryContract;
    nodeRegistryContractReadonly;
    contractFactory;
    rpcProviderSource;
    config;
    identity;
    constructor(contractFactory, rpcProviderSource, config, identity) {
        this.contractFactory = contractFactory;
        this.rpcProviderSource = rpcProviderSource;
        this.config = config;
        this.identity = identity;
        this.nodeRegistryContractReadonly = this.contractFactory.createReadContract(toEthereumAddress(this.config.contracts.storageNodeRegistryChainAddress), NodeRegistryABI, rpcProviderSource.getProvider(), 'storageNodeRegistry');
    }
    async connectToContract() {
        if (this.nodeRegistryContract === undefined) {
            const chainSigner = await this.identity.getTransactionSigner(this.rpcProviderSource);
            this.nodeRegistryContract = this.contractFactory.createWriteContract(toEthereumAddress(this.config.contracts.storageNodeRegistryChainAddress), NodeRegistryABI, chainSigner, 'storageNodeRegistry');
        }
    }
    async setStorageNodeMetadata(metadata) {
        await this.connectToContract();
        const ethersOverrides = await getEthersOverrides(this.rpcProviderSource, this.config);
        if (metadata !== undefined) {
            await waitForTx(this.nodeRegistryContract.createOrUpdateNodeSelf(JSON.stringify(metadata), ethersOverrides));
        }
        else {
            await waitForTx(this.nodeRegistryContract.removeNodeSelf(ethersOverrides));
        }
    }
    async getStorageNodeMetadata(nodeAddress) {
        const [resultNodeAddress, metadata] = await this.nodeRegistryContractReadonly.getNode(nodeAddress);
        const NODE_NOT_FOUND = '0x0000000000000000000000000000000000000000';
        if (resultNodeAddress !== NODE_NOT_FOUND) {
            return JSON.parse(metadata);
        }
        else {
            throw new StreamrClientError('Node not found, id: ' + nodeAddress, 'NODE_NOT_FOUND');
        }
    }
};
StorageNodeRegistry = __decorate([
    scoped(Lifecycle.ContainerScoped),
    __param(2, inject(ConfigInjectionToken)),
    __param(3, inject(IdentityInjectionToken)),
    __metadata("design:paramtypes", [ContractFactory,
        RpcProviderSource, Object, Identity])
], StorageNodeRegistry);
export { StorageNodeRegistry };
